// *** WebApi Service - Plugin ***

// const LINKS_URL = '../static/data/javascript-links.json'
const LINKS_URL = 'static/data/javascript-links.json'
const ARTIKEL_URLS = [
    {id: 0, title: 'template', url: 'static/data/cms-content/artikel/template.md'},
    {id: 1, title: 'shadow-dom', url: 'static/data/cms-content/artikel/shadow-dom.md'},
    {id: 2, title: 'cloud-openshift-kubernets', url: 'static/data/cms-content/artikel/cloud-openshift-kubernets.md'}
]

let WEBAPI_URL = ''
if (process.env.NODE_ENV === 'production') {
    // $$$
    this.id ? WEBAPI_URL = 'static/lib/api.php?id=' + this.id : WEBAPI_URL = 'static/lib/api.php?id=undefined'
} else {
    if (this && this.id) {
        WEBAPI_URL = 'http://localhost/static/lib/api.php?id=' + this.id
    } else {
        WEBAPI_URL = 'http://localhost/static/lib/api.php?id=undefined'
    }
}

export default {
    install: function (Vue, options) {
        // console.log('WebApiService plugin - install...')
        // console.log('this: '); console.dir(this); console.log('Vue: '); console.dir(Vue)

        /* Vue.prototype.$webapi = {
            // name: 'WebApiService Plugin',
            anonymousGetLinks: function () {
                Vue.http.get(LINKS_URL)
                    .then(response => {
                        // console.log('getLinks.$http.get THIS: response'); console.dir(response)
                        if (response.ok === true) {
                            this.tree = response.body
                            // console.log('getLinks.$http.get THIS: body'); console.dir(response.body)
                        }
                    })
                    .catch(response => {
                        console.log('getLinks.$http.get CATCH: response'); console.dir(response)
                    })
            }
        } */

        /* Vue.webapi = {
            getLinks: function () {
                // $$$
            }
        } */

        Vue.mixin({
            /* created: function () {
              // something logic ...
            }, */
            methods: {
                webapi$anonymousGetLinks: function () {
                    return Vue.http.get(LINKS_URL)
                },
                webapi$anonymouseGetArtikel: function (artikelId) {
                    artikelId = parseInt(artikelId)
                    if (artikelId >= 0 && artikelId < ARTIKEL_URLS.length) {
                        // FIX: Workaround as IE11 doesn't know array.find()
                        // let matchArtikel = ARTIKEL_URLS.find(item => item.id === artikelId)
                        let matchArtikel = null
                        ARTIKEL_URLS.forEach(item => {
                            if (item.id === artikelId && matchArtikel === null) {
                                matchArtikel = item
                            }
                        })
                        return Vue.http.get(matchArtikel.url)
                            .then(response => {
                                matchArtikel.content = response.body
                                return matchArtikel
                            })
                            .catch(err => {
                                console.error('webapi$anonymouseGetArtikel err', err)
                                throw err
                            })
                    } else {
                        // $$$ INVALID ARTIKEL-ID
                        return Promise.resolve('Artikel not found.')
                    }
                },
                webapi$anonymouseGetListArtikels: function () {
                    return Promise.resolve(ARTIKEL_URLS)
                },
                webapi$anonymouseSendContactMessage (message) {
                    // $$$
                    // TEST-CASES:
                    // return new Promise((resolve, reject) => {
                    // **     setTimeout(() => { resolve({ errors: [] }) }, 2000)
                    // **     setTimeout(() => { resolve({ errors: ['Da ist der Wurm drinn'] }) }, 2000)
                    // **     throw new Error('Jetzt kracht\'s mal richtig hier.')
                    // })

                    let body = {
                        fu: 'send_contact_message',
                        body: message
                    }
                    return Vue.http.post(WEBAPI_URL, body, { url: WEBAPI_URL })
                },
                webapi$connect: function (credentials) {
                    let body = {
                        fu: 'connect',
                        body: { credentials } // $$$ TODO: Credentials missing!
                    }
                    return Vue.http.post(WEBAPI_URL, body, {url: WEBAPI_URL})
                },
                webapi$login: function (credentials) {
                    let body = {
                        fu: 'login',
                        body: { credentials }
                    }
                    return Vue.http.post(WEBAPI_URL, body, {url: WEBAPI_URL})
                },
                webapi$logoff: function (userId, token) {
                    let body = {
                        fu: 'logoff',
                        body: { userId: userId, token: token }
                    }

                    // $$$ TODO: Cryptographical Access-Token needed here !!
                    let bearerToken = btoa(userId) + '.' + btoa(token)
                    console.log(`webapi$logoff: Authorization: Bearer ${bearerToken}`)
                    debugger // eslint-disable-line no-debugger

                    return Vue.http.post(WEBAPI_URL, body, {
                        url: WEBAPI_URL,
                        headers: { Authorization: `Bearer ${bearerToken}` }
                    })
                },
                webapi$write_tree: function (userId, token, links) {
                    let body = {
                        fu: 'write_tree',
                        body: links
                    }

                    // $$$ TODO: Cryptographical Access-Token needed here !!
                    let bearerToken = btoa(userId) + '.' + btoa(token)
                    console.log(`webapi$write_tree: Authorization: Bearer ${bearerToken}`)

                    return Vue.http.post(WEBAPI_URL, body, {
                        url: WEBAPI_URL,
                        headers: { Authorization: `Bearer ${bearerToken}` }
                    })
                }
            }
        }) // END - Mixin
    }
}



// WEBPACK FOOTER //
// ./src/plugins/WebApiService.js